<template>
  <div id="mapa" class="mapa">
     <GmapMap
      :center="{lat:-27.185859, lng:-51.518168}"
      map-type-id="roadmap"
      ref="gMapRef"
      :style="css"
    >
      <slot></slot>
      <GmapMarker
        :center="{lat:-27.185859, lng:-51.518168}"
        :clickable="true"
        :draggable="true"
        @click="center=m.position"
      />
    </GmapMap>
  </div>
</template>
<script>
import {gmapApi} from 'vue2-google-maps'
export default {
  name: 'Mapa',
  props: {
    points: Array,
    enableInfowindow: Boolean,
    fitBounds: Boolean,
    zoom: Number,
    css: String
  },
  computed: {
    google: gmapApi
  },
  data () {
    return {
      markers: []
    }
  },
  watch: {
    points: {
      deep: true,
      handler () {
        this.resetMarkers()
      }
    }
  },
  mounted () {
    this.generateMap()
  },
  methods: {
    generateMap () {
      let centerPoint = null
      let mapZoom = null
      centerPoint = {lat: parseFloat(this.points[0].latitude), lng: parseFloat(this.points[0].longitude)}
      mapZoom = this.zoom

      var mapOptions = {
        mapTypeControl: false, // desativa opcao de escolha de mapa
        mapTypeId: 'roadmap', // desativa opcao de escolha de mapa
        panControl: false, // desativa movimentacao no mapa
        disableDefaultUI: false,
        center: centerPoint
      }
      this.$refs.gMapRef.$mapPromise.then((map) => {
        map.setOptions(mapOptions)
        this.setMarkers(map)
        map.setZoom(mapZoom)
      })
    },
    resetMarkers () {
      this.markers.forEach(marker => {
        marker.setMap(null)
      })
      this.$refs.gMapRef.$mapPromise.then((map) => {
        this.setMarkers(map)
      })
    },
    setMarkers (gMap) {
      if (!this.points) {
        return []
      }
      // var bounds = new this.google.maps.LatLngBounds()
      this.points.forEach(element => {
        var marker = new this.google.maps.Marker({
          position: {
            lat: parseFloat(element.latitude),
            lng: parseFloat(element.longitude)
          },
          map: gMap,
          icon: element.icon
        })
        if (this.enableInfowindow) {
          marker.addListener('click', () => {
            var infoWindow = this.generateInfoWindow(element.title, element.description ? element.description : '')
            infoWindow.open(gMap, marker)
          })
        }
        this.markers.push(marker)
      })
    },
    generateInfoWindow (title, description) {
      var contentString =
        '<div id="content">' +
        '<div class="box-map">' +
        '<h2 class="map-title">' + title + '</h2>' +
        '<p>' + description + '</p></div></div>'
      var infowindow = new this.google.maps.InfoWindow({
        content: contentString
      })

      return infowindow
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';

.mapa{
  height: 29em;
  margin: 0;
  @media (max-width: 767px) {
    height: 350px!important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ContatoMapa.vue